import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';
import {WarehouseService} from '../../shared/service/warehouse-service';
import {AccountService} from '../../login/account.service';
import {IWarehouse} from '../../shared/model/warehouse.model';

@Component({
  selector: 'app-warehouse-selection-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogContent, MatDialogActions],
  templateUrl: './warehouse-selection-dialog.html',
  styleUrl: './warehouse-selection-dialog.css'
})
export class WarehouseSelectionDialog implements OnInit {
  selectedCode: string | null = null;
  warehouses: IWarehouse[] = [];

  constructor(
    public dialogRef: MatDialogRef<WarehouseSelectionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { warehouseCodes: string[] },
    private warehouseService: WarehouseService,
    private accountService: AccountService
  ) {
  }

  ngOnInit() {
    this.loadWarehouses();
  }

  loadWarehouses() {
    const addressNumber = this.accountService.userIdentity()?.user.addressNumber;
    if (!addressNumber) return;

    this.warehouseService.findByCustomerAn(addressNumber).subscribe({
      next: (response) => {
        const allWarehouses = response.body?.warehouses ?? [];
        this.warehouses = allWarehouses.filter(w => 
          this.data.warehouseCodes.includes(w.code ?? '')
        );
      },
      error: () => {
        this.warehouses = [];
      }
    });
  }

  selectWarehouse(code: string) {
    this.selectedCode = code;
  }

  confirm() {
    if (this.selectedCode) {
      this.dialogRef.close(this.selectedCode);
    }
  }

  isSelected(code: string): boolean {
    return this.selectedCode === code;
  }
}
